import { render, staticRenderFns } from "./shareActivityList.vue?vue&type=template&id=2fc064b4&"
import script from "./shareActivityList.vue?vue&type=script&lang=js&"
export * from "./shareActivityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports